<template lang="pug">
    article.article-body(
        :class='`theme-${articledata.color}`'
        )

        Corners(
            :footnote='footnote'
        )

        .article-body__wrapper

            h2.article-body__title(v-html='articledata.rawlead')

            .article(
                v-if='articledata.blocks'
                v-for='(article, articleIndex) in articledata.blocks',
                :class='article.type',
                :data-block='articleIndex',
                :data-article='name'
                )

                .article__title(
                    v-html='article.title'
                    )

                .article__wrapper


                    .article__text.article__text--one
                        p(v-html='article.text[0]')


                    .article__text.article__text--two(
                        v-if='article.text[1]'
                        )
                        p(v-html='article.text[1]')


                    .article__questions
                        .question.question--one
                            span(
                                v-html='article.questions[0]'
                                )
                            svg
                                use(
                                    :xlink:href='"#checks"'
                                )
                        .question.question--two
                            span(
                                v-html='article.questions[1]'
                                )
                            svg
                                use(
                                    :xlink:href='"#checks"'
                                )


                    .article__points

                        .article__point.article__point--one
                            p(v-html='article.points[0]')
                        
                        .article__point.article__point--two(
                            v-if='article.points[1]'
                            )
                            p(v-html='article.points[1]')


                    .article__image.article__image--one
                        svg.svg-image
                            use(
                                :xlink:href='`#${article.img[0]}`'
                            )
                    
                    .article__image.article__image--two(
                        v-if='article.img[1]'
                        )
                        svg.svg-image
                            use(
                                :xlink:href='`#${article.img[1]}`'
                            )
                    
                .article__attention(
                    v-if='articleIndex === 0'
                    )
                    p(
                        v-html='footnote'
                        )
                    
        .article-body__footer(
            v-if='articledata.footer'
            :class='{colorbg: articledata.footer.text}'
            )

            .article-body__footer-wrapper(
                v-if='articledata.footer.text'
                )

                .article-body__footer-text(
                    v-html='articledata.footer.text'
                )

                .article-body__footer-image
                    svg.svg-footer-image
                        use(
                            xlink:href='#partthreebottom'
                        )
            
            .article-body__footer-next(v-else)
                
                .footer__next
                    span(
                        v-html='articledata.footer.link.text',
                        @click='gotoNext(articledata.footer.link.goto)'
                        )
                
                .footer__share
                    Share

                a.footer__sber(
                    href='https://www.sberbank.ru/ru/s_m_business?utm_source=secretmag.ru&utm_medium=cpm&utm_campaign=bankingservice_specialproject_corporate_logo_dec-2019%20(https://www.sberbank.ru/ru/s_m_business?utm_source=secretmag.ru&utm_medium=cpm&utm_campaign=bankingservice_specialproject_corporate_logo_dec-2019)',
                    @click='logoClick("sberbank")'
                    )

                    svg
                        use(
                            xlink:href='#sberlogo'
                        )
                


</template>

<script>
const Corners = () => import('@/components/Corners.vue');
const Share = () => import('@/components/Share.vue');

export default {
    name: 'Selector',

    components: {
        Corners,
        Share
    },

    props: {
        articledata: Object,
        name: String,
        footnote: String
    },

    data() {
        return {
            blocks: this.articledata.blocks
        };
    },

    mounted() {
        // console.log(this.article);
    },

    methods: {
        logoClick(logoName) {
            this.$gtm.trackEvent({
                event: 'eventTracking',
                category: 'Button',
                action: 'click',
                label: `Logo ${logoName} clicked`
            });
        },

        gotoNext(name) {
            this.$emit('update:articleActive', name);
            this.$emit('scrollToArticles');
        }
    }
};
</script>

<style lang="scss">
@import '../assets/css/vars.scss';
@import '../assets/css/corners.scss';

.article-body {
    position: relative;
    min-height: 100vh;
    min-height: calc(var(--vh) * 100);
    padding: calc(var(--block-width) * 0.5) 0;
    padding-bottom: 80px;
    display: flex;
    flex-wrap: wrap;

    @media (--viewport-tablet) {
        padding: 0;
        padding-top: calc(var(--block-height) * 2);
    }

    &__wrapper {
        width: 100%;
        max-width: var(--content-width);
        padding: 0 100px;
        margin: 0 auto;
        padding-top: calc(var(--block-height) * 2);

        @media (--viewport-tablet) {
            padding-left: 20px;
            padding-right: 20px;
        }
    }

    &__title {
        color: #9a9b9f;
        font-size: 1.9rem;
        line-height: 1;
        max-width: 630px;

        @media (--viewport-tablet) {
            text-align: center;
            line-height: 1;
            font-size: 1.37rem;
        }
    }

    &__footer {
        width: 100%;
        position: relative;
        z-index: 50;

        @media (--viewport-tablet) {
            padding: 40px 20px;
        }

        &.colorbg {
            background: var(--theme-alt);
            margin-bottom: -80px;
            padding: calc(var(--block-height) * 4) 0;

            @media (--viewport-tablet) {
                padding: 40px 20px;
            }
        }

        &-wrapper {
            max-width: var(--content-width-inner);
            margin: 0 auto;
        }

        &-text {
            padding-left: 150px;

            @media (--viewport-tablet) {
                padding: 0;
            }
        }

        &-image {
            margin-top: 40px;

            @media (--viewport-tablet) {
                padding: 0;
            }

            svg {
                width: 100%;
            }
        }

        &-next {
            display: block;

            @media (--viewport-tablet) {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

            .footer {
                &__next {
                    position: relative;
                    margin-bottom: 30px;
                    padding-bottom: 30px;
                    width: 100%;
                    text-align: center;
                    cursor: pointer;

                    span {
                        display: inline-block;
                        background: #f3f3f3;
                        border: 1px solid #9b9da0;
                        border-radius: 3px;
                        padding: 12px 12px;
                        line-height: 1;
                    }

                    &:after {
                        position: absolute;
                        bottom: 0;
                        display: block;
                        width: 100%;
                        height: 5px;
                        background-color: var(--color-green);

                        @media (--viewport-tablet) {
                            content: '';
                        }
                    }
                }

                &__sber {
                    display: none;
                    margin-top: 20px;

                    @media (--viewport-tablet) {
                        display: block;
                    }

                    svg {
                        width: 65vw;
                        height: 20vw;
                    }
                }

                &__share {
                    position: relative;
                    width: 100%;
                    height: auto;
                    display: none;
                    flex-direction: column;
                    align-items: center;
                    justify-content: flex-end;

                    @media (--viewport-tablet) {
                        display: flex;
                    }

                    .share {
                        &__inner {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            justify-content: center;

                            span {
                                margin: 0 20px;
                                background: var(--color-green);
                                border-radius: 50%;

                                svg {
                                    fill: white;
                                    width: 20px;
                                    height: 20px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

.article {
    width: 100%;
    margin: 80px 0;

    &__wrapper {
        position: relative;
        width: 100%;
        max-width: var(--content-width-inner);
        margin: 0 auto;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 60px;
        grid-row-gap: 60px;
        padding-top: 40px;

        @media (--viewport-tablet) {
            grid-template-columns: calc(100vw - 40px);
        }
    }

    &__title {
        font-size: 40px;
        margin-bottom: 20px;
        max-width: 650px;
        line-height: 1.05;

        @media (--viewport-tablet) {
            width: 100%;
            text-align: center;
        }

        &:after {
            content: '';
            display: block;
            width: 350px;
            height: 22px;
            margin-top: 20px;
            background: var(--theme);

            @media (--viewport-tablet) {
                display: inline-block;
                width: 40vw;
                height: 5px;
                margin-left: 20vw;
                margin-right: 20vw;
            }
        }
    }

    &__text {
        font-size: 1rem;
        line-height: 1.57;

        &--one {
            grid-area: to;
            padding-left: 150px;

            @media (--viewport-tablet) {
                padding-left: 0;
            }
        }
        &--two {
            grid-area: tt;
        }
    }

    &__questions {
        grid-area: qu;
        position: relative;
        font-size: 1rem;
        padding: 60px 0;
        border-top: 6px solid var(--theme);
        border-bottom: 6px solid var(--theme);
        align-self: baseline;

        .question {
            position: relative;
            font-size: 1rem;
            padding: 15px 50px 15px 20px;
            border-radius: 8px;
            border: 1px solid;
            line-height: 1.58;

            &--one {
                width: 90%;
                border-color: #9a9b9f;
                background: rgba(216, 216, 216, 0.32);
                margin-bottom: 30px;

                svg {
                    fill: #3f4656;
                }
            }

            &--two {
                width: 90%;
                margin-left: 10%;
                border-color: var(--theme);
                background: var(--theme-alt);

                svg {
                    fill: var(--theme);
                }
            }

            svg {
                position: absolute;
                bottom: 10px;
                right: 10px;
                width: 29px;
                height: 17px;
            }
        }
    }

    &__points {
        grid-area: po;
        font-size: 1rem;
        padding-left: 150px;

        @media (--viewport-tablet) {
            padding-left: 0;
        }
    }

    &__point {
        font-size: 1rem;

        &--two {
            margin-top: 30px;
        }
    }

    &__image {
        font-size: 1rem;
        align-self: center;

        &--one {
            grid-area: io;
        }
        &--two {
            grid-area: it;
        }
    }

    &__attention {
        display: none;

        @media (--viewport-tablet) {
            display: block;
            border: 1px solid var(--color-green);
            font-size: 1rem;
            padding: 15px 50px 15px 20px;
            border-radius: 8px;
            border: 1px solid;
            line-height: 1.58;
            background-color: var(--color-green-alt);
            margin-top: 20px;
        }
    }

    &.two-images-right {
        .article {
            &__wrapper {
                grid-template-areas:
                    'to io'
                    'qu tt'
                    'qu it'
                    'po po';

                @media (--viewport-tablet) {
                    grid-template-areas:
                        'to'
                        'io'
                        'qu'
                        'tt'
                        'it'
                        'po';
                }
            }

            &__text {
                &--one {
                    padding-left: 0;
                }
            }
        }
    }

    &.two-images-left {
        .article {
            &__wrapper {
                grid-template-areas:
                    'io to'
                    'po qu'
                    'it qu';

                @media (--viewport-tablet) {
                    grid-template-areas:
                        'io'
                        'to'
                        'po'
                        'it'
                        'qu';
                }
            }

            &__text {
                &--one {
                    padding-left: 0;
                }
            }

            &__points {
                padding-left: 0;
            }
        }
    }

    &.one-image-right {
        .article {
            &__wrapper {
                grid-template-areas:
                    'to to'
                    'qu io'
                    'po po';

                @media (--viewport-tablet) {
                    grid-template-areas:
                        'to'
                        'qu'
                        'io'
                        'po';
                }
            }
        }

        &--two-text {
            .article {
                &__wrapper {
                    grid-template-areas:
                        'to to'
                        'qu tt'
                        'qu io'
                        'po po';

                    @media (--viewport-tablet) {
                        grid-template-areas:
                            'to'
                            'tt'
                            'qu'
                            'io'
                            'po';
                    }
                }
            }
        }
    }

    &.one-image-left {
        .article {
            &__wrapper {
                grid-template-areas:
                    'to to'
                    'io qu'
                    'po po';

                @media (--viewport-tablet) {
                    grid-template-areas:
                        'to'
                        'io'
                        'qu'
                        'po';
                }
            }
        }
    }

    &.both-side-images {
        .article {
            &__wrapper {
                grid-template-areas:
                    'io to'
                    'qu it'
                    'po po';

                @media (--viewport-tablet) {
                    grid-template-areas:
                        'io'
                        'to'
                        'qu'
                        'it'
                        'po';
                }
            }

            &__text {
                &--one {
                    padding-left: 0;
                }
            }
        }
    }
}

.svg-image {
    width: 361px;
    height: 374px;

    @media (--viewport-tablet) {
        width: calc(100vw - 40px);
        height: calc(100vw - 40px * (394 / 236));
    }

    svg {
        width: 361px;
        height: 374px;

        @media (--viewport-tablet) {
            width: calc(100vw - 40px);
            height: calc(100vw - 40px * (394 / 236));
        }
    }

    use {
        width: 361px;
        height: 374px;

        @media (--viewport-tablet) {
            width: calc(100vw - 40px);
            height: calc(100vw - 40px * (394 / 236));
        }

        .addmoney {
            opacity: 0.3;
        }
    }
}

.article {
    &[data-article='firststeps'][data-block='0'] {
        .article__image--one {
            margin-top: -150px;

            @media (--viewport-tablet) {
                margin: 0;
            }
        }

        .article__image--two {
            margin-top: -120px;
            margin-bottom: -50px;

            @media (--viewport-tablet) {
                margin-top: -30vw;
                margin-bottom: -20vw;
            }
        }
    }

    &[data-article='firststeps'][data-block='1'] {
        .article__image--one {
            .svg-image {
                margin-top: -79px;
                margin-bottom: -70px;
            }
        }

        .article__image--two {
            .svg-image {
                @media (--viewport-tablet) {
                    margin-top: -20vw;
                    margin-bottom: -10vw;
                }
            }
        }
    }

    &[data-article='firststeps'][data-block='2'] {
        .article__image--one {
            .svg-image {
                @media (--viewport-tablet) {
                    margin-top: -10vw;
                    margin-bottom: -20vw;
                }
            }
        }
    }

    &[data-article='firststeps'][data-block='3'] {
        .article__image--two {
            .svg-image {
                @media (--viewport-tablet) {
                    margin-top: -20vw;
                    margin-bottom: -20vw;
                }
            }
        }
    }

    &[data-article='growing'][data-block='0'] {
        .article__image--one {
            .svg-image {
                @media (--viewport-tablet) {
                    margin-top: -20vw;
                    margin-bottom: -20vw;
                }
            }
        }
    }

    &[data-article='growing'][data-block='1'] {
        .article__image--one {
            .svg-image {
                margin-top: -95px;
                margin-bottom: -54px;
            }
        }

        .article__image--two {
            .svg-image {
                @media (--viewport-tablet) {
                    margin-top: -20vw;
                    margin-bottom: -20vw;
                }
            }
        }
    }

    &[data-article='growing'][data-block='3'] {
        .article__image--one {
            .svg-image {
                @media (--viewport-tablet) {
                    margin-top: -20vw;
                    margin-bottom: -20vw;
                }
            }
        }
    }

    &[data-article='convolution'][data-block='0'] {
        .article__image--one {
            .svg-image {
                margin-top: -95px;
                margin-bottom: -54px;

                @media (--viewport-tablet) {
                    margin-top: -30vw;
                    margin-bottom: -30vw;
                }
            }
        }

        .article__image--two {
            .svg-image {
                @media (--viewport-tablet) {
                    margin-top: -20vw;
                    margin-bottom: -20vw;
                }
            }
        }
    }

    &[data-article='convolution'][data-block='1'] {
        .article__image--one {
            .svg-image {
                @media (--viewport-tablet) {
                    margin-top: -10vw;
                    margin-bottom: -10vw;
                }
            }
        }

        .article__image--two {
            .svg-image {
                @media (--viewport-tablet) {
                    margin-top: -20vw;
                    margin-bottom: -20vw;
                }
            }
        }
    }

    &[data-article='convolution'][data-block='2'] {
        .article__image--one {
            .svg-image {
                @media (--viewport-tablet) {
                    margin-top: -15vw;
                    margin-bottom: -15vw;
                }
            }
        }
    }
}
</style>
